import type { MarketCountryCode, MonetaryAmount } from '@backmarket/http-api'

export const QUOTES_LISTING_GRADES = {
  NOT_FUNCTIONAL_CRACKED: 'NOT_FUNCTIONAL_CRACKED',
  NOT_FUNCTIONAL_USED: 'NOT_FUNCTIONAL_USED',
  FUNCTIONAL_CRACKED: 'FUNCTIONAL_CRACKED',
  FUNCTIONAL_USED: 'FUNCTIONAL_USED',
  FUNCTIONAL_GOOD: 'FUNCTIONAL_GOOD',
  FUNCTIONAL_FLAWLESS: 'FUNCTIONAL_FLAWLESS',
} as const

export type QUOTES_GRADES_ENUM = keyof typeof QUOTES_LISTING_GRADES

export const LISTING_PUBLICATION_STATE = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
} as const

export type ListingStateType = keyof typeof LISTING_PUBLICATION_STATE

export const BuyBackQuoteListingStates = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const

export type BuyBackQuoteListingState = keyof typeof BuyBackQuoteListingStates

export interface BuyBackQuote {
  marketCode: MarketCountryCode
  product: BuyBackQuoteProduct
  listings: Array<BuyBackQuoteListing>
}

export interface BuyBackQuotes {
  totalCount: number
  quotes: Array<BuyBackQuote>
}

export interface BuybackQuotePostDetails {
  listingId: string
  productId: string
  grade: QUOTES_GRADES_ENUM
  status: number
  title: string
  type: string
}

export interface BuyBackQuoteProduct {
  productId: string
  title: string
  image: string
  availableMarkets?: MarketCountryCode[]
}

export interface BuyBackQuoteListing {
  listingId: string | null
  backboxPrice: MonetaryAmount | null
  grade: QUOTES_GRADES_ENUM
  hasBackbox: boolean
  price: MonetaryAmount
  priceToWinBackbox: MonetaryAmount | null
  state: ListingStateType
  sku: string | null
}

export interface PostBuyBackQuoteListing {
  grade: string
  price?: MonetaryAmount | null
  sku?: string | null
  state?: BuyBackQuoteListingState
}

export interface BuyBackQuotePricingEstimation {
  grade: QUOTES_GRADES_ENUM
  priceToWinBackbox: MonetaryAmount
}

export type QuotesQuery = {
  pageNumber?: number
  pageSize?: number
  marketCode?: MarketCountryCode
  productId?: string
  authorization?: string
  releaseYear?: number
  sku?: string
  hasBackbox?: boolean
  grades?: QUOTES_GRADES_ENUM[]
  brand?: string
  model?: string
}

export type GetListingsImportMetadata = {
  csvColumns: Array<string>
  csvTemplateLink: string
}

export type PostListings = {
  task: number
}
